import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A wizard choice kept in the URL query (decision 2): the wizard can be left, resumed and shared. Several setters in
 * one tick build on each other (same trick as the statistics pages).
 */
let pending: URLSearchParams | null = null;

export function useWizardParam(key: string): [string, (v: string) => void] {
  const [params, setParams] = useSearchParams();
  const value = params.get(key) ?? '';
  const set = useCallback(
    (v: string) =>
      setParams(
        (cur) => {
          const next = new URLSearchParams(pending ?? cur);
          if (v) next.set(key, v);
          else next.delete(key);
          if (!pending) queueMicrotask(() => (pending = null));
          pending = next;
          return next;
        },
        { replace: true }
      ),
    [key, setParams]
  );
  return [value, set];
}
